<button [type]="submit() ? 'submit' : 'button'" [style.width]="width()" class="btn" [ngClass]="buttonStyleClass()" (click)="click()" [disabled]="disabled() ? true : null">
  <div class="icon-layout">
    @if (icon()) {
      <app-svg-icon [icon]="icon()"></app-svg-icon>
    }
    <ng-content></ng-content>
  </div>
</button>
